import React, { useCallback, useContext, useEffect, useState } from "react";
import styles from "./styles/BeneficiaryConditions.module.css";
import { Navigate, useNavigate } from "react-router-dom";
import { submitCaptcha } from "../../Utils/captcha";
import {
  acceptBeneficiaryTerms,
  getBeneficiaryTerms,
} from "../../Utils/beneficiary";
import Loading from "../Loading/Loading";
import { decryptText } from "../../Utils/OstreonEncryption";
import { Logout } from "../../Utils/Logout";
import { formatDate } from "../../Utils/formatDate";
import { LanguageContext } from "../../Context/changeLanguageProvider";

export function BeneficiaryConditions() {
  const navigate = useNavigate();
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [content, setContent] = useState(
    websiteCurrentLang.content.Beneficiary.BeneficiaryCondition
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.Beneficiary.BeneficiaryCondition);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const [checked1, setChecked1] = useState(false);
  const [checked2, setChecked2] = useState(false);
  const [termsClicked, setTermsClicked] = useState(false);
  const [privacyClicked, setPrivacyClicked] = useState(false);
  const [CustomerFullName, setCustomerFullName] = useState();
  const [BeneficiaryEmail, setBeneficiaryEmail] = useState();
  const [beneficiaryAccessDate, setbeneficiaryAccessDate] = useState();
  const [loaded, setLoaded] = useState(false);

  const handleTermsClick = () => {
    setTermsClicked(true);
  };

  const handlePrivacyClick = () => {
    setPrivacyClicked(true);
  };

  const [msg, setMsg] = useState({
    checkbox: "",
  });

  const clearMsg = () => {
    setTimeout(() => {
      setMsg({
        checkbox: "",
        button: "",
      });
    }, 3000);
  };

  const handleClick = async () => {
    console.log("Checking");
    if (
      checked1 === false ||
      checked2 === false ||
      termsClicked === false ||
      privacyClicked === false
    ) {
      console.log("Ha entrado");
      setMsg({
        checkbox: content.BeneficiaryConditionMsg1,
      });
      clearMsg();
      return;
    }

    acceptBeneficiaryTerms()
      .then((res) => {
        if (res.status === 200) return res.json();
        else throw new Error("FailedToAccept");
      })
      .then(async (data) => {
        const beneficiary_key = window.sessionStorage.getItem(
          "ostreon_beneficiary_key"
        );
        const encrypted_key = data?.encrypted_key;
        if (!beneficiary_key || !encrypted_key) throw new Error("Missing keys");
        const ostreon_key = await decryptText(beneficiary_key, encrypted_key);
        window.sessionStorage.setItem("ostreon_key", ostreon_key);
        window.sessionStorage.removeItem("ostreon_beneficiary_terms");
        navigate("/beneficiary/home", { replace: true });
      })
      .catch((e) => {
        console.log(e);
        setMsg({ ...msg, button: dublicatedcontent.dublicatedText67 });
      });
  };
  useEffect(() => {
    getBeneficiaryTerms()
      .then((res) => {
        if (res.status !== 200) throw new Error(res.status);
        else return res.json();
      })
      .then((data) => {
        console.log(data);
        setCustomerFullName(data?.fullname);
        setBeneficiaryEmail(data?.username);
        setbeneficiaryAccessDate(data?.expiration_date);
      })
      .catch((e) => {
        console.log(e);
        navigate("/", { replace: true });
      })
      .finally((_) => {
        setLoaded(true);
      });
  }, []);
  return (
    <div className={styles.main}>
      {loaded ? (
        <>
          <div className={styles.page_title}>
            {dublicatedcontent?.dublicatedText82}
          </div>
          <div className={styles.container}>
            <div className={styles.title}>
              {content.BeneficiaryConditionText1}{" "}
              <span className={styles.hardcode}>{BeneficiaryEmail}</span>,
            </div>
            <p>
              {content.BeneficiaryConditionText2}
              <span className={styles.hardcode}> {CustomerFullName}</span>
              {content.BeneficiaryConditionText3}
              <br></br>
            </p>
            <p>{content.BeneficiaryConditionText4} </p>
            <p>{content.BeneficiaryConditionText5}</p>
            <p>
              <span className={styles.hardcode}> {CustomerFullName}</span>{" "}
              {content.BeneficiaryConditionText6}
            </p>
            <p>
              {content.BeneficiaryConditionText7}
              <span className={styles.hardcode}> {CustomerFullName}</span>{" "}
              {content.BeneficiaryConditionText8}
            </p>
            <div className={styles.title}>
              {content.BeneficiaryConditionText9}
            </div>
            <p>{content.BeneficiaryConditionText10}</p>
            <p>
              {content.BeneficiaryConditionText11}
              <span className={styles.hardcode}> {CustomerFullName} </span>
              {content.BeneficiaryConditionText12}
              <span className={styles.hardcode}> {CustomerFullName} </span>
              {content.BeneficiaryConditionText13}
              <span className={styles.hardcode}> {CustomerFullName} </span>
              {content.BeneficiaryConditionText14}
            </p>
            <p>
              {content.BeneficiaryConditionText15}
              <span className={styles.hardcode}> {CustomerFullName}</span>
              {content.BeneficiaryConditionText16}
            </p>
            <p>
              <strong>
                {content.BeneficiaryConditionText17}
                <span className={styles.red_color}>
                  {" "}
                  {content.BeneficiaryConditionText18}{" "}
                </span>
              </strong>
            </p>
            <p>{content.BeneficiaryConditionText19}</p>
            <p>
              {content.BeneficiaryConditionText20}
              <u>
                {content.BeneficiaryConditionText21}
                {beneficiaryAccessDate && (
                  <span>
                    {content.BeneficiaryConditionText22}
                    <span className={styles.hardcode}>
                      {formatDate(Number(beneficiaryAccessDate)).split(" ")[0]}
                    </span>
                  </span>
                )}
                {content.BeneficiaryConditionText23}
              </u>
              {content.BeneficiaryConditionText24}
            </p>
            <p>
              <strong className={styles.red_color}>
                {content.BeneficiaryConditionText25}
              </strong>
            </p>
            <p>{content.BeneficiaryConditionText26}</p>
            <p>{content.BeneficiaryConditionText27}</p>
            {/*
              ---- the introduction video ----

              Two things here are about it being WATCHABLE rather than about
              it being embedded.

              `youtube-nocookie.com` is YouTube's privacy-enhanced host: it
              serves the same video without setting tracking cookies until
              the viewer presses play. The right default for this page on its
              own merits -- it is the first thing a beneficiary sees, and
              they never asked to be tracked -- and it is also the host that
              privacy blockers are least likely to refuse.

              `referrerPolicy` states the origin explicitly. Error 153 is the
              player refusing because it could not verify the page embedding
              it, so the one thing worth making certain is that the origin is
              sent. What is left after that -- a shield, an extension, a
              corporate proxy -- this application does not control, and
              YouTube's own error box already offers "Watch on YouTube", so a
              blocked viewer is not stranded.
            */}
            <div className={styles.video_section}>
              <div className={styles.video_title}>
                {content.BeneficiaryConditionText28}
              </div>
              <iframe
                className={styles.video}
                src={
                  localStorage?.getItem("language") === "fr"
                    ? "https://www.youtube-nocookie.com/embed/J9AhMs8mHS8"
                    : "https://www.youtube-nocookie.com/embed/NXbvuTdUDG0"
                }
                title="YouTube video player"
                /*
                  camelCase: React passes an unknown lowercase attribute
                  straight through but warns about each one, and these two
                  have real DOM properties to set.
                */
                frameBorder="0"
                /*
                  Stated rather than left to the default, so the player is
                  always told which origin is embedding it -- the check that
                  fails as error 153 when it is not.
                */
                referrerPolicy="strict-origin-when-cross-origin"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
            <div className={styles.terms}>
              {
                <div className={styles.checkbox_error}>
                  {msg.checkbox ? msg.checkbox : null}
                </div>
              }
              <div className={styles.checkbox_field}>
                <div
                  onClick={(e) => {
                    setChecked1(!checked1);
                  }}
                  className={`${styles.checkbox} ${
                    checked1 ? styles.checked : styles.not_checked
                  }`}
                />
                <div className={styles.checkbox_text}>
                  {content.BeneficiaryConditionText29}
                  <a
                    onClick={() => {
                      handleTermsClick();
                    }}
                    className={styles.link}
                    href="/terms-and-conditions"
                    target="_blank"
                  >
                    {" "}
                    {dublicatedcontent.dublicatedText38}{" "}
                  </a>
                  {content.BeneficiaryConditionText31}
                  <a
                    onClick={() => {
                      handlePrivacyClick();
                    }}
                    className={styles.link}
                    href="/privacy-policy"
                    target="_blank"
                  >
                    {" "}
                    {dublicatedcontent.dublicatedText39}{" "}
                  </a>
                  <div className={styles.red_color2}>
                    {content.BeneficiaryConditionText33}
                  </div>
                </div>
              </div>

              <div className={styles.checkbox_field}>
                <div
                  onClick={(e) => {
                    setChecked2(!checked2);
                  }}
                  className={`${styles.checkbox} ${
                    checked2 ? styles.checked : styles.not_checked
                  }`}
                />
                <div className={styles.checkbox_text}>
                  {content.BeneficiaryConditionText34}
                </div>
              </div>
            </div>
            <div className={styles.actions}>
              <div onClick={() => handleClick()} className={styles.bluebutton}>
                {content.BeneficiaryConditionText35}
              </div>
              <div className={styles.checkbox_error}>
                {msg.button ? msg.button : null}
              </div>
            </div>
          </div>
        </>
      ) : (
        <div style={{ height: "40vh" }}>
          <Loading text={content.BeneficiaryConditionText36} />
        </div>
      )}
    </div>
  );
}
